import { useTranslation } from 'react-i18next';
import Button from '@/components/common/Button';
import Modal from '@/components/common/Modal';
import type { GroupListItemDataFragment } from '@/gql/graphql';
import DetailCard from '../shared/DetailCard';
import ViewCourse from '../shared/ViewCourses';

interface ViewGroupProps {
    open: boolean;
    group?: GroupListItemDataFragment;
    onClose: () => void;
}

const ViewGroup = ({ open, onClose, group }: ViewGroupProps) => {
    const { t } = useTranslation('groups');

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={group?.name || t('viewGroupModal.title')}
            largeTitle
            className="mt-2 w-full space-y-4 sm:max-w-3xl sm:min-w-[600px]"
            footer={
                <div className="mt-5 pt-4 sm:mt-4 sm:flex sm:flex-row sm:items-center sm:justify-end">
                    <Button onClick={onClose} variant="secondary">
                        {t('viewGroupModal.close')}
                    </Button>
                </div>
            }
        >
            {group && (
                <div className="flex flex-col gap-5">
                    <DetailCard group={group} />
                    <ViewCourse group={group} />
                </div>
            )}
        </Modal>
    );
};

export default ViewGroup;
